
import PropTypes from 'prop-types';
import { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { WordmarkLogo } from 'mastodon/components/logo';
import NavigationPortal from 'mastodon/components/navigation_portal';
import { transientSingleColumn } from 'mastodon/is_mobile';

import ColumnLink from './column_link';
import DisabledAccountBanner from './disabled_account_banner';
import FollowRequestsColumnLink from './follow_requests_column_link';
import NotificationsCounterIcon from './notifications_counter_icon';
import SignInBanner from './sign_in_banner';

const messages = defineMessages({
  home: { id: 'tabs_bar.home', defaultMessage: 'Home' },
  notifications: { id: 'tabs_bar.notifications', defaultMessage: 'Notifications' },
  direct: { id: 'navigation_bar.direct', defaultMessage: 'Messages' },
  advancedInterface: {
    id: 'navigation_bar.advanced_interface',
    defaultMessage: 'Open in advanced web interface',
  },
  openedInClassicInterface: {
    id: 'navigation_bar.opened_in_classic_interface',
    defaultMessage: 'Posts, accounts, and other specific pages are opened by default in the classic web interface.',
  },
});

class NavigationPanel extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    identity: PropTypes.object.isRequired,
  };

  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  render () {

    const { intl } = this.props;
    const { signedIn, disabledAccountId } = this.context.identity;

    let banner = undefined;

    if (transientSingleColumn)
      banner = (
        <div className='switch-to-advanced'>
          {intl.formatMessage(messages.openedInClassicInterface)}{' '}
          <a
            href={`/deck${location.pathname}`}
            className='switch-to-advanced__toggle'
          >
            {intl.formatMessage(messages.advancedInterface)}
          </a>
        </div>
      );

    return (
      <div className='navigation-panel'>

        <div className='navigation-panel__logo'>
          <Link to='/' className='column-link column-link--logo'>
            <WordmarkLogo />
          </Link>
          {!banner && <hr />}
        </div>

        {banner && (
          <div className='navigation-panel__banner'>
            {banner}
          </div>
        )}

        {signedIn && (
          <>
            <ColumnLink
              transparent
              to='/home'
              icon='home'
              text={intl.formatMessage(messages.home)}
            />

            <ColumnLink
              transparent
              to='/notifications'
              icon={<NotificationsCounterIcon className='column-link__icon' />}
              text={intl.formatMessage(messages.notifications)}
            />

            <FollowRequestsColumnLink />

            <ColumnLink
              transparent
              to='/conversations'
              icon='at'
              text={intl.formatMessage(messages.direct)}
            />

              <a
                href='pinchechess://social'
                className='column-link'
                style={{ marginTop: '8px' }}
                title='Pinche Chess®'
                aria-label='Pinche Chess®'
              >
                <svg
                  className='column-link__icon'
                  width='22'
                  height='22'
                  viewBox='0 0 64 64'
                  aria-hidden='true'
                  focusable='false'
                  style={{ fill: 'currentColor' }}
                >
                  <path d='M29 3h6v8h8v6h-8v7c9 2 15 10 15 20H14c0-10 6-18 15-20v-7h-8v-6h8V3zm-9 45h24l5 8H15l5-8zm-8 11h40v4H12v-4z' />
                </svg>
                <span>Pinche Chess®</span>
              </a>

            <hr />


          </>
        )}

        {!signedIn && (
          <div className='navigation-panel__sign-in-banner'>
            <hr />
            {disabledAccountId ? <DisabledAccountBanner /> : <SignInBanner />}
          </div>
        )}

        <NavigationPortal />

      </div>
    );
  }

}

export default injectIntl(NavigationPanel);

